module.exports = __webpack_public_path__ + "static/13-699970759c04a79d14cc70bec4563034.png";